import fetchService from '@/services/fetchService';

export const state = {
  loading: true,
  data: {},
};

export const actions = {
  async FETCH_ALLPOSTS({ commit }) {
    try {
      const response = await fetchService.fetchData(
        '/job-posts?_sort=position:ASC'
      );
      commit('SET_DATA', response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async FETCH_DATA(id, { commit }) {
    console.log('FETCH');
    try {
      const response = await fetchService.fetchData(`/job-posts/${id}`);

      // localStorage.setItem('exercises', response.data);
      commit('SET_DATA', response.data);
      // return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  // SET_INITIAL_DISPLAYED({ commit }) {
  //   if (!state.loading) {
  //     commit('SET_INITIAL_DISPLAYED', 0);
  //   }
  // },
  SHOW_NEXT_CANDIDATE({ commit }) {
    commit('SET_INITIAL_DISPLAYED', 1);
  },
  HANDLE_SUBMIT(payload) {
    console.log(payload);
  },
};
export const mutations = {
  SET_DATA(state, data) {
    console.log(data);
    state.data = data;
    state.loading = false;
  },
  UPDATE_DISPLAYED_APPLICANT(displayedJobSeeker, index) {
    console.log(index);
    displayedJobSeeker.applicants[index].displayed = true;
  },
};

export const getters = {
  jobPost(state) {
    return state.data;
  },
  loading(state) {
    return state.loading;
  },
  jobseekers(state) {
    return state.data.applicants;
  },
  displayedJobSeeker(state) {
    return state.data.applicants.filter((item) => item.displayed);
  },
  // displayedJobSeekerId(state, getters) {
  //   return getters.displayedJobSeeker;
  // },
  queuedJobSeeker(state, getters) {
    const filtered = [];

    getters.jobseekers.map((item) => {
      if (item.rating) {
        return;
      } else {
        filtered.push(item);
      }
    });
    console.log(filtered);
    return filtered;
    // return state.data.applicants.filter(
    //   (item) => item.id !== this.displayedJobSeekerId()
    // );

    // item is not in the completed array
    // item is not currently displayed
  },
  completedJobSeeker(state) {
    return state.data.applicants.filter((item) => item.rating);
  },
};
